import React from 'react';
import TechWork from '../components/sections/TechWork/TechWork';

export const FEATURE_COMPONENTS: Record<string, React.FC> = {
  'maintenance-mode': TechWork,
};
